import React from "react";
import { useHackathon } from "../../contexts/HackathonContext";
import { groups } from "../../data/groups";
import { SectionHeading } from "./SectionHeading";
import { TeamPhoto } from "./TeamPhoto";
import { teamPhotos } from "../../data/teamPhotos";
import { teamSubjects } from "../../data/teamSubjects";
export function TeamsSection() {
  const {
    state
  } = useHackathon();
  return <section id="teams" className="scroll-mt-20 bg-cream py-24 md:py-32" data-id="element-680" data-mp="1r7on808j0wsd">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8" data-id="element-681" data-mp="1r5bvivcyv824">
        <SectionHeading title="The teams" intro="Eleven students, five teams, two continents. Every team pairs Link School of Business in Brazil with Mahindra University in India." data-id="element-682" data-mp="1w715s8sd7hp5" />

        <div className="mt-16 space-y-20 md:mt-24 md:space-y-28" data-id="element-683" data-mp="25xdpjyscv6u8">
          {groups.map(g => {
          const members = state.students.filter(s => s.groupId === g.id);
          const profile = state.groups.find(p => p.id === g.id);
          const mentors = state.mentors.filter(m => m.groupIds.includes(g.id));
          const subject = teamSubjects[g.id] ?? null;
          return <article key={g.id} className="grid gap-8 border-t-2 border-ink pt-6 lg:grid-cols-[minmax(0,340px)_1fr] lg:gap-12" data-id="element-684" data-mp="17otub3kp0mmv">
                <header data-id="element-685" data-mp="yuouvvrhu2vq">
                  <p className="text-[12px] font-bold uppercase tracking-wide" data-id="element-686" data-mp="ytdu84tchb8u">Team</p>
                  <p className="mt-2 font-display text-[clamp(6rem,12vw,10rem)] leading-none" data-id="element-687" data-mp="tvm2pbwm3r56">{String(g.id).padStart(2, "0")}</p>
                  <p className="mt-6 text-[12px] font-bold uppercase tracking-wide text-ink/60" data-id="element-688" data-mp="ouo9m4a2dcow">Track</p>
                  <p className="mt-1 font-display text-3xl uppercase leading-tight" data-id="element-689" data-mp="jxodal30noaz">
                    {subject ?? "To be announced"}
                  </p>
                  {profile?.productName && <p className="mt-3 inline-block rounded-full border border-ink px-4 py-1.5 text-[12px] font-bold uppercase tracking-wide" data-id="element-690" data-mp="2eae958cy37l0">
                      {profile.productName}
                    </p>}
                  {profile?.tagline && <p className="mt-2 text-[15px] text-ink/75" data-id="element-691" data-mp="ce6tr7pruyef">{profile.tagline}</p>}
                  {mentors.length > 0 && <p className="mt-4 text-[13px] font-semibold uppercase tracking-wide text-ink/60" data-id="element-692" data-mp="3usxsk7qxr761">
                      Mentor{mentors.length > 1 ? "s" : ""}: {mentors.map(m => m.name).join(", ")}
                    </p>}
                </header>
                <TeamPhoto teamId={g.id} members={members} photo={teamPhotos[g.id]} data-id="element-693" data-mp="vd16yc9l7qsh" />
              </article>;
        })}
        </div>
      </div>
    </section>;
}